import React from "react"
import useFeatureFlag from "services/featureFlags"
import { Form } from "sharedTypes"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import EditorSection from "components/Builder/components/EditorSection"
import RegistrationSettingsSwitches from "pages/EventShow/Forms/FormManagement/SelectedForm/RegistrationFields/RegistrationSettingsSwitches"
import { Control, UseFormSetValue } from "react-hook-form"
import formatRegistrationFields from "pages/EventShow/Forms/FormManagement/SelectedForm/RegistrationFields/formatRegistrationFields"
import MessagingSection from "../EditFormModalContent/EditFormModalSettings/Messaging"

type Props = {
  form: Form
  control: Control<any, any>
  setValue: UseFormSetValue<any>
  enableNameAndEmailToggle?: boolean
}

const RegistrationSettings = ({
  form, control, setValue, enableNameAndEmailToggle,
}: Props) => {
  const { whatsappMessaging } = useFeatureFlag()
  const fields = formatRegistrationFields(form, enableNameAndEmailToggle, { whatsappMessaging })

  return (
    <>
      <SidePanelHeader>Registration</SidePanelHeader>
      <EditorSection>
        <RegistrationSettingsSwitches
          fields={fields}
          control={control}
          setValue={setValue}
          syncPhoneWithWhatsappOptIn={whatsappMessaging}
        />
      </EditorSection>
      <MessagingSection form={form} />
    </>
  )
}

export default RegistrationSettings
